import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";
import Save from "@material-ui/icons/Save";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { Button, colors, Container, Hidden, Paper } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import { insh as inshst } from "../../../../Context/InshSt";

export default function SafesTaswyaForm(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        AutoOptions,
        rptParamsSub,
        onChangeDataSub,
        onChangeAutoDataSubunit,
        valueAutosSub,
        selectItems,
        unitsOptions,
        onChangeBarcodeSearch,
        onChangeAutoDataSubCurr,
        onSubmit,
        onChangeDataSubQ,
        onChangeDataSubP,
        MathChangIdata,
        editing
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();

    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>

            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField
                        type="text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("forms:barcode")}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        name="barcode"
                        value={rptParamsSub.barcode}
                        autoFocus={true}

                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onChangeBarcodeSearch(event);
                                    document.getElementById("val2").focus();
                                }
                            },
                        }}
                        onFocus={handleFocus}

                        onChange={onChangeDataSub("barcode")}
                        />
                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        value={valueAutosSub.curr}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                           onChangeAutoDataSubCurr("symbol", newValue)
                           document.getElementById("val2").focus()
                        }}
                        id="controllable-states-demo"
                        size="small"
                        disabled={editing}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        options={AutoOptions.items}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("item_name")}
                                variant="outlined"
                                size="small"
                            />

                        )}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        value={valueAutosSub.units}
                        labelPlacement=""
                        onChange={(event, newValue) => {
                            onChangeAutoDataSubunit("units", newValue)
                        }}
                        id="units"
                        size="small"
                        disabled={selectItems}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        options={unitsOptions}
                        disableClearable={true}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.unitName
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("unit")}
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="val1"
                        label={t("quantity-available")}
                        className={clasTF.rootSafe}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}

                        InputProps={{ className: claslbl.clrSafe,readOnly:true }}
                        type="text"
                        name="val1" value={rptParamsSub.val1} 
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="val2"
                        label={t("acual_quantity")}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}
                        className={clasTF.rootSafe}
                        InputProps={{
                            className: claslbl.clrSafe,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onSubmit(event);
                                    document.getElementById("barcode").focus();
                                }
                            },
                        }}
                        type="number"
                        name="val2" value={rptParamsSub.val2} onChange={onChangeDataSubP('val2')}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="diff"
                        label={t("difference")}

                        className={clasTF.rootSafe}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}

                        InputProps={{ className: claslbl.clrSafe, readOnly: true }}
                        type="text"
                        name="diff" value={rptParamsSub.diff}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="Price"
                        label={t("price")}
                        style={{ backgroundColor: colors.blue[50], marginBlock: 5 }}

                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrSafe }}
                        type="text"
                        name="Price" value={rptParamsSub.Price} onChange={onChangeDataSubP('Price')}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={2} xs={2} style={{ paddingBottom: "0.5rem" }}>

                    <Container
                        maxWidth={false}
                        style={{
                            padding: "5px",
                        }}
                    >

                        <Hidden smUp={["sm"]}>

                            <Grid item>
                                <Button
                                    // disabled={fetching}
                                    variant="contained"
                                    startIcon={<Save />}
                                    size="small"
                                    style={
                                        (inshst.safe.iconBtn,
                                            { borderRadius: 0 ,backgroundColor:"#3f51b5"})
                                    }
                                    className={[clasui.button]}
                                    onClick={onSubmit}

                                    // onClick={() => addItemsList(rptParamsSub)}
                                >
                                    {editing===true?t("update"): t("download")}

                                </Button>
                            </Grid>
                        </Hidden>
                        <Hidden only={["xs"]}>

                            <Grid item>
                                <Button
                                    // disabled={false}
                                    variant="contained"
                                    startIcon={<Save />}
                                    size="large"
                                    style={
                                        (inshst.sal.iconBtn,
                                            { borderRadius: 0 ,backgroundColor:"#3f51b5"})
                                    }
                                    className={[clasui.button]}
                                    // onClick={() => addItemsList(rptParamsSub)}
                                    onClick={onSubmit}

                                >
                                    {editing===true?t("update_item"): t("download_item")}
                                </Button>
                            </Grid>
                        </Hidden>

                    </Container>

                </Grid>
            </Grid>

        </React.Fragment >
    );

}